module.exports = __webpack_public_path__ + "static/img/u6.72c213e0.png";